var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCoolDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.726,
    height: 45.323,
    viewBox: "0 0 31.726 45.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_cool_down_FILL0_wght400_GRAD0_opsz24",
    d: "M215.863-834.677,200-850.54l3.173-3.229L213.6-843.345V-859.6h4.532v16.26l10.424-10.368,3.173,3.173Zm-2.266-29.46v-6.8h4.532v6.8Zm0-11.331V-880h4.532v4.532Z",
    transform: "translate(-200 880)",
    fill: "#ee2b7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCoolDown);
export default __webpack_public_path__ + "static/media/arrow_cool_down.2e99d45896de0c1815d8dd8e68c74f6c.svg";
export { ForwardRef as ReactComponent };